/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_ChangesInputs */

const en_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Changes`)
};

const fr_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les modifications`)
};

const de_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen speichern`)
};

const it_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva modifiche`)
};

const ru_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить изменения`)
};

const es_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar cambios`)
};

const zh_cn2_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存更改`)
};

const ja_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更を保存`)
};

const hi_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तनों को सुरक्षित करें`)
};

const pt_pt2_save_changes = /** @type {(inputs: Save_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar alterações`)
};

/**
* | output |
* | --- |
* | "Save Changes" |
*
* @param {Save_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_changes = /** @type {((inputs?: Save_ChangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_ChangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_save_changes(inputs)
	if (locale === "de") return de_save_changes(inputs)
	if (locale === "it") return it_save_changes(inputs)
	if (locale === "ru") return ru_save_changes(inputs)
	if (locale === "es") return es_save_changes(inputs)
	if (locale === "zh-CN") return zh_cn2_save_changes(inputs)
	if (locale === "ja") return ja_save_changes(inputs)
	if (locale === "hi") return hi_save_changes(inputs)
	if (locale === "pt-PT") return pt_pt2_save_changes(inputs)
	return en_save_changes(inputs)
});